module.exports = __webpack_public_path__ + "img/shop-amazoncn.43fbab95.png";